import Modal from '@Components/Shared/Modals/Modal';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const ProductDetail = (props) => {
    // eventually we may want this to be a separate page instead of a modal, but for now we will keep it as a modal
    return (
        <Modal containerClassName='product-detail' onEscapeKeyClose={props.toggleProductDetail}>
            <Modal.Header onClose={props.toggleProductDetail}>
                <div className="product-detail__top-row">
                    <Modal.Title headingClassName='show-all-modal-title'>
                        {props.productToView.title}
                    </Modal.Title>
                </div>
                <div className='product-detail__category'>
                    {props.productToView.category}
                </div>
            </Modal.Header>
            <Modal.Body>
                {props.modalProductImages?.length > 0 &&
                    <div className="product-detail__image-slider-container">
                        <div className="product-detail__image-slider">
                            <IconButton
                                className="product-detail__image-slider-btn"
                                size="small"
                                onClick={() => props.handlePrevImage(props.productToView.id, props.modalProductImages.length)}
                                disabled={props.modalProductImages.length <= 1}
                            >
                                <ArrowBackIosNewIcon fontSize="small" />
                            </IconButton>

                            <img
                                className="product-detail__image-slider-img"
                                src={props.modalActiveImage?.url}
                                alt={props.modalActiveImage?.altText || props.productToView.title}
                            />

                            <IconButton
                                className="product-detail__image-slider-btn"
                                size="small"
                                onClick={() => props.handleNextImage(props.productToView.id, props.modalProductImages.length)}
                                disabled={props.modalProductImages.length <= 1}
                            >
                                <ArrowForwardIosIcon fontSize="small" />
                            </IconButton>
                        </div>

                        <div className='product-detail__thumbnail-slider'>
                            {props.modalProductImages?.map((image, index) => (
                                <button
                                    key={`${props.productToView.id}-${image.id || index}`}
                                    type="button"
                                    onClick={() => props.setProductImageIndex(props.productToView.id, index)}
                                    className={`product-detail__thumbnail-slider-btn ${index === props.modalActiveImageIndex ? 'active' : ''}`}
                                >
                                    <img
                                        src={image.url}
                                        alt={image.altText || props.productToView.title}
                                        className='product-detail__thumbnail-slider-img'
                                    />
                                </button>
                            ))}
                        </div>
                    </div>}
                <div className='product-detail__info'>
                    <div className='product-detail__price'>
                        <strong>{props.formattedPrice}</strong>
                    </div>
                    <div className='product-detail__btn-wrapper'>
                        <Button
                            className="product-detail__btn"
                            style={{ width: '80%', margin: '15px 0' }}
                            onClick={() => props.handleAddToCart(props.productToView, 1)}
                        >
                            Add To Cart
                        </Button>
                    </div>
                    <div className='product-detail__description'>
                        <div dangerouslySetInnerHTML={{ __html: props.productToView.description }} />
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ProductDetail;